import React from 'react';
import { Snackbar } from '@mui/material';
import { Alert } from 'global/components/alerts';
import { get } from 'global/lib/lodash';

export default (props) => {
  const { alerts, setAlerts } = props;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={!!alerts}
      autoHideDuration={6000}
      onClose={() => setAlerts()}
      {...props}
      {...get(props, 'alerts.messageProps', {})}
    >
      <Alert onClose={() => setAlerts()} severity={get(alerts, 'severity', 'success')}>
        {typeof get(alerts, 'message') === 'function' ? alerts.message() : <div dangerouslySetInnerHTML={{ __html: get(alerts, 'message', '') }}></div>}
      </Alert>
    </Snackbar>
  );
};
